const DownArrow = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.99928 14C9.41595 14 8.83262 13.775 8.39095 13.3334L2.95762 7.90003C2.71595 7.65837 2.71595 7.25837 2.95762 7.0167C3.19928 6.77503 3.59928 6.77503 3.84095 7.0167L9.27428 12.45C9.67428 12.85 10.3243 12.85 10.7243 12.45L16.1576 7.0167C16.3993 6.77503 16.7993 6.77503 17.041 7.0167C17.2826 7.25837 17.2826 7.65837 17.041 7.90003L11.6076 13.3334C11.166 13.775 10.5826 14 9.99928 14Z"
			fill="black"
		/>
	</svg>
);
export default DownArrow;
